export default __webpack_public_path__ + "static/media/gable.1d563e3f.png";